import { Component, OnInit } from '@angular/core';
import {
  Validators,
  FormBuilder,
  FormGroup,
  FormControl,
  ValidatorFn,
  AbstractControl
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { Application } from 'src/app/shared/models/Application.model';
import { FileExtensionvValidator } from 'src/app/shared/utils/file.validator';

@Component({
  selector: 'app-private',
  templateUrl: './private-person.component.html',
  styleUrls: ['./private-person.component.css']
})
export class PrivatePersonComponent implements OnInit {
  nrOfPages: number = 5;
  pageCounter: number = 1;
  privateForm: FormGroup;
  dataPolicy: boolean;

  privStiftelser = [
    { id: 0, value: 'Oscar och Maria Rappes stiftelse' },
    { id: 1, value: 'Stiftelsen Jan Lundahls minnesfond' },
    { id: 2, value: 'Anna Tryggs Stiftelse' },
    { id: 3, value: 'Stiftelsen Folke Anderssons fond' },
    { id: 4, value: 'Stiftelsen för dövas vård och bästa' },
    //{ id: 5, value: 'Stiftelsen Anna-Britta och Bengt Attefelts fond' },
    { id: 6, value: 'Stiftelsen Amelie Högfeldts minnesfond' },
    { id: 7, value: 'Femte Dövstumsdistriktets stiftelse' },
    { id: 8, value: 'Stiftelsen SKM:s fond för missionsforskning' }
  ];

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private applicationService: ApplicationService
  ) {
    this.privateForm = this.formBuilder.group({
      1: this.formBuilder.group({
        Ar: [new Date().getFullYear(), []],
        Typ: ['Privatperson', []],
        Admin: ['', []],
        Status: ['Aktiv', []],
        Comment: ['', []],

        StiftelseNamn: ['', [Validators.required]],
        MotiveringAnsokan: [
          '',
          [Validators.required, Validators.maxLength(3000)]
        ],
        Belopp: [
          null,
          [
            Validators.required,
            Validators.maxLength(10),
            Validators.pattern('[0-9]*')
          ]
        ],
        TidigareStod: ['', [Validators.required]],
        StodStiftelse: ['', []],
        StodAr: ['', []]
      }),
      2: this.formBuilder.group({
        Fornamn: ['', [Validators.required, Validators.maxLength(30)]],
        Namn: ['', [Validators.required, Validators.maxLength(30)]],
        IdNr: [
          '',
          [
            Validators.required,
            Validators.minLength(12),
            Validators.maxLength(13)
          ]
        ],
        Gatuadress: ['', [Validators.required, Validators.maxLength(30)]],
        Co: ['', [Validators.maxLength(30)]],
        Postnummer: [
          '',
          [
            Validators.required,
            Validators.minLength(5),
            Validators.maxLength(6)
          ]
        ],
        Postort: ['', [Validators.required, Validators.maxLength(30)]],
        Telefonnummer: [
          '',
          [Validators.minLength(9), Validators.maxLength(15)]
        ],
        Mobilnummer: ['', [Validators.minLength(9), Validators.maxLength(15)]],
        Mejladress: ['', [Validators.required, Validators.email]],
        Bank: ['', [Validators.required, Validators.maxLength(30)]],
        Clearingnummer: [
          '',
          [
            Validators.required,
            Validators.minLength(4),
            Validators.maxLength(5)
          ]
        ],
        Kontonummer: [
          '',
          [
            Validators.required,
            Validators.minLength(7),
            Validators.maxLength(15)
          ]
        ]
      }),
      3: this.formBuilder.group({
        Civilstatus: ['', [Validators.required]],
        AntalBarn: ['', [Validators.required]],
        BarnAlder: ['', [Validators.maxLength(30)]],
        Bostadstyp: ['', [Validators.required]],
        Boendekostnad: [
          null,
          [
            Validators.required,
            Validators.maxLength(10),
            Validators.pattern('[0-9]*')
          ]
        ],
        Bostadsbidrag: [
          null,
          [
            Validators.required,
            Validators.maxLength(10),
            Validators.pattern('[0-9]*')
          ]
        ]
      }),
      4: this.formBuilder.group({
        Arbete1: [
          null,
          [Validators.maxLength(10), Validators.pattern('[0-9]*')]
        ],
        Akassa1: [
          null,
          [Validators.maxLength(10), Validators.pattern('[0-9]*')]
        ],
        Sjukpenning1: [
          null,
          [Validators.maxLength(10), Validators.pattern('[0-9]*')]
        ],
        PensionLivranta1: [
          null,
          [Validators.maxLength(10), Validators.pattern('[0-9]*')]
        ],
        OvrigInkomst1: [
          null,
          [Validators.maxLength(10), Validators.pattern('[0-9]*')]
        ],
        Forsorjningsstod1: [
          null,
          [Validators.maxLength(10), Validators.pattern('[0-9]*')]
        ],
        Arbete2: [
          null,
          [Validators.maxLength(10), Validators.pattern('[0-9]*')]
        ],
        Akassa2: [
          null,
          [Validators.maxLength(10), Validators.pattern('[0-9]*')]
        ],
        Sjukpenning2: [
          null,
          [Validators.maxLength(10), Validators.pattern('[0-9]*')]
        ],
        PensionLivranta2: [
          null,
          [Validators.maxLength(10), Validators.pattern('[0-9]*')]
        ],
        OvrigInkomst2: [
          null,
          [Validators.maxLength(10), Validators.pattern('[0-9]*')]
        ],
        Forsorjningsstod2: [
          null,
          [Validators.maxLength(10), Validators.pattern('[0-9]*')]
        ],
        TotalInkomst: [0, [Validators.required, Validators.pattern('[0-9]*')]]
      }),
      5: this.formBuilder.group({
        Skattedeklaration: this.formBuilder.array(
          [],
          [Validators.required, FileExtensionvValidator('png, pdf, txt, jpg')]
        ),
        Lakarintyg: this.formBuilder.array(
          [],
          [Validators.required, FileExtensionvValidator('png, pdf, txt, jpg')]
        ),
        IntygDiakon: this.formBuilder.array(
          [],
          [FileExtensionvValidator('png, pdf, txt, jpg')]
        ),
        OvrigaDokument: this.formBuilder.array(
          [],
          [FileExtensionvValidator('png, pdf, txt, jpg')]
        )
      })
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(queryParams => {
      if (queryParams.steg != null) {
        this.pageCounter = parseInt(queryParams.steg);
      } else {
        this.pageCounter = 1;

        this.router.navigate([], {
          queryParams: { steg: 1 },
          queryParamsHandling: 'merge'
        });
      }
    });
  }

  navigate(direction: number): void {
    this.pageCounter += direction;
    this.router.navigate([], {
      queryParams: { steg: this.pageCounter },
      queryParamsHandling: 'merge'
    });
  }

  cancelApplication() {
    this.privateForm.reset();
    // this.router.navigate(['']);
    window.location.href =
      'https://www.svenskakyrkan.se/sok-stiftelser-och-fonder';
  }

  onSubmit(): void {
    var obj = {};

    for (let i = 1; i <= Object.values(this.privateForm.value).length; i++) {
      obj = Object.assign(obj, this.privateForm.value[i]);
    }

    this.applicationService
      .applicationToJSON(obj as Application)
      .subscribe(res => {
        this.router.navigate(['inskickad']);
      });
    this.router.navigate(['inskickad']);
  }
}
